import React from 'react';
import { RadarAxisConfig } from '../../config/radarAxes';

interface RadarPreferenceEditorProps {
  axes: RadarAxisConfig[];
  values: Record<string, number>;
  onChange: (key: string, value: number) => void;
  title?: string;
}

export const RadarPreferenceEditor: React.FC<RadarPreferenceEditorProps> = ({
  axes,
  values,
  onChange,
  title,
}) => {
  return (
    <div className="space-y-3">
      {title && <h4 className="font-semibold text-sm text-gray-700">{title}</h4>}
      {axes.map(axis => (
        <div key={axis.key} className="flex items-center gap-3">
          <label
            className="w-28 text-sm text-gray-600 flex-shrink-0 cursor-help"
            title={axis.description}
          >
            {axis.label}
          </label>
          <input
            type="range"
            min={axis.min}
            max={axis.max}
            step={0.5}
            value={values[axis.key] ?? axis.defaultPreference}
            onChange={e => onChange(axis.key, parseFloat(e.target.value))}
            className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-orange-500"
          />
          <span className="w-8 text-sm text-right font-mono text-gray-700">
            {(values[axis.key] ?? axis.defaultPreference).toFixed(1)}
          </span>
        </div>
      ))}
    </div>
  );
};
